import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import { Modal } from 'rsuite';
import ReservationsWithOnholdItemList from '../../../containers/inventory/ReservationsWithOnholdItemList';
import {
  ItemType,
  PackageType
} from '../../../constants/inventory/InventoryTypes';
import { InventoryAvailabilityType } from '../../../interfaces/inventory';

const OnHoldReservationsModal = ({
  show,
  type,
  availability,
  onHide,
  onCanceled
}) => {
  if (!availability) return null;

  const itemId = get('item.id', availability);
  const locationId = get('location.id', availability);
  const zoneId = get('zone.id', availability);
  const details = [
    get('item.name', availability),
    get('location.name', availability),
    type === ItemType ? get('zone.name', availability) : null
  ]
    .filter(Boolean)
    .join(' • ');

  return (
    <Modal show={show} onHide={onHide} size="lg" overflow>
      <Modal.Header>
        <Modal.Title>Reservations with onhold items</Modal.Title>
        {details && (
          <p style={{ margin: '8px 0 0', color: '#8e8e93' }}>{details}</p>
        )}
      </Modal.Header>
      <Modal.Body>
        <ReservationsWithOnholdItemList
          key={`${type}-${itemId}-${locationId}-${zoneId || ''}`}
          type={type}
          itemId={itemId}
          locationId={locationId}
          zoneId={zoneId}
          onCanceled={onCanceled}
        />
      </Modal.Body>
    </Modal>
  );
};

OnHoldReservationsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([ItemType, PackageType]).isRequired,
  availability: InventoryAvailabilityType,
  onHide: PropTypes.func.isRequired,
  onCanceled: PropTypes.func
};

OnHoldReservationsModal.defaultProps = {
  availability: null,
  onCanceled: () => {}
};

export default OnHoldReservationsModal;
